// for handling select options on sales appointments page...
((document) => {
  // init variables...
  let btnSelectAction = null;
  let selectOption = null;

  // Initialise select option component....
  function init() {
    // console.log('appoingt options: ', selectOptionsConfig);
    selectOption = document.querySelector('#js-option-selector');
    btnSelectAction = document.querySelector('.js-option-selecter__btn');

    selectOption.addEventListener('change', handleSelectionChanged);
    btnSelectAction.setAttribute('href', selectOption.value);
    btnSelectAction.addEventListener('click', triggerDataLayer);
  }

  // update button href with selected value...
  function handleSelectionChanged() {
    btnSelectAction.setAttribute('href', selectOption.value);
  }

  // Event listener to push dataLayer event on button click
  function triggerDataLayer() {
    let vehicleType = '';
    switch (selectOption.value) {
      case '/book-an-appointment/sales/new/':
        vehicleType = 'new-appointment';
        break;
      case '/book-an-appointment/sales/used/':
        vehicleType = 'used-appointment';
        break;
      case '/book-an-appointment/sales/vans/':
        vehicleType = 'vans-appointment';
        break;
      case '/book-an-appointment/sales/motability/':
        vehicleType = 'motability-appointment';
        break;
    }
    window.dataLayer.push({
      event: 'appointmentBookingApp',
      appointmentDetails: [
        {
          step: 1,
          vehicleType: vehicleType,
          appointmentType: '',
          dealership: '',
          date: '',
          time: '',
        },
      ],
    });
  }

  vm.onload(init);
})(document);
